"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Used to display images/videos.
 */


var CardMedia = function CardMedia(_ref) {
  var className = _ref.className,
      scale = _ref.scale,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["className", "scale", "children"]);

  return _react2.default.createElement("div", _extends({
    className: (0, _classnames3.default)("mdc-card__media", _defineProperty({}, "mdc-card__media--" + scale, scale), className)
  }, other), children);
};

CardMedia.propTypes = {
  /** Image scale */
  scale: (0, _propTypes.oneOf)(["square", "16-9"])
};
exports.default = CardMedia;